import { Drawer, List, ListItem, ListItemText, ListItemIcon, Grid } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import FolderIcon from '@mui/icons-material/Folder';
import AddBoxIcon from '@mui/icons-material/AddBox';

const Slidebar_Dashboard = () => {

    const location = useLocation();

    const menuItems = [
        { text: 'Proyectos', icon: <FolderIcon />, path: '/dashboard/proyectos/' },
        { text: 'Blogs', icon: <FolderIcon />, path: '/dashboard/blogs/' },
    ];

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
             sx={{backgroundColor:'#223B59', }} >

            <Drawer variant="permanent"
                 sx={{width: 240}} >
                <List sx={{ width: 240, pt:10}}>
                    {menuItems.map((item) => (
                        <ListItem
                            button
                            key={item.text}
                            component={Link}
                            to={item.path}
                            selected={location.pathname === item.path}
                        >
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.text} />
                        </ListItem>
                    ))}
                </List>
            </Drawer>

        </Grid>
    )

}
export default Slidebar_Dashboard;